import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-19cb6169"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "details-inner"
};
const _hoisted_2 = {
  class: "details-top"
};
const _hoisted_3 = {
  class: "details-type-box"
};
const _hoisted_4 = {
  class: "details-type-number"
};
const _hoisted_5 = {
  class: "details-type-name"
};
const _hoisted_6 = {
  class: "details-buttons"
};
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "details-line"
}, null, -1));
const _hoisted_8 = {
  class: "details-content"
};
const _hoisted_9 = {
  class: "details-content-inner"
};
const _hoisted_10 = {
  class: "details-content-product"
};
const _hoisted_11 = {
  class: "details-content-info"
};
const _hoisted_12 = {
  class: "details-content-asin"
};
const _hoisted_13 = {
  class: "details-content-title"
};
const _hoisted_14 = {
  class: "details-content-photo"
};
const _hoisted_15 = ["src"];
const _hoisted_16 = {
  class: "details-table"
};
const _hoisted_17 = {
  class: /*#__PURE__*/_normalizeClass(['details-row', 'readonly'])
};
const _hoisted_18 = {
  class: "details-row-title"
};
const _hoisted_19 = {
  class: "details-row-value"
};
const _hoisted_20 = {
  class: /*#__PURE__*/_normalizeClass(['details-row', 'readonly'])
};
const _hoisted_21 = {
  class: "details-row-title"
};
const _hoisted_22 = {
  key: 0,
  class: "details-row-value"
};
const _hoisted_23 = {
  class: /*#__PURE__*/_normalizeClass(['details-row', 'readonly'])
};
const _hoisted_24 = {
  class: "details-row-title"
};
const _hoisted_25 = {
  class: "details-row-value"
};
const _hoisted_26 = {
  class: /*#__PURE__*/_normalizeClass(['details-row'])
};
const _hoisted_27 = {
  class: "details-row-title"
};
const _hoisted_28 = {
  key: 0,
  class: "details-row-value"
};
const _hoisted_29 = {
  class: /*#__PURE__*/_normalizeClass(['details-row'])
};
const _hoisted_30 = {
  class: "details-row-title"
};
const _hoisted_31 = {
  key: 0,
  class: "details-row-value"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_app_icon = _resolveComponent("app-icon");
  const _component_alerts_priority = _resolveComponent("alerts-priority");
  const _component_alerts_status = _resolveComponent("alerts-status");
  const _component_alerts_assignee = _resolveComponent("alerts-assignee");
  return _openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['details', {
      open: $props.modelValue
    }])
  }, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, _toDisplayString($options.typeNumber), 1), _createElementVNode("div", _hoisted_5, _toDisplayString($options.name), 1)]), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", {
    class: _normalizeClass(['details-button', {
      disabled: !$options.prev?.id
    }]),
    onClick: _cache[0] || (_cache[0] = (...args) => $options.onPrev && $options.onPrev(...args))
  }, [_createVNode(_component_app_icon, {
    icon: "arrow-up2",
    size: 20,
    color: "#757575"
  })], 2), _createElementVNode("div", {
    class: _normalizeClass(['details-button', {
      disabled: !$options.next?.id
    }]),
    onClick: _cache[1] || (_cache[1] = (...args) => $options.onNext && $options.onNext(...args))
  }, [_createVNode(_component_app_icon, {
    icon: "arrow-down2",
    size: 20,
    color: "#757575"
  })], 2), _hoisted_7, _createElementVNode("div", {
    class: "details-button",
    onClick: _cache[2] || (_cache[2] = (...args) => $options.onClose && $options.onClose(...args))
  }, [_createVNode(_component_app_icon, {
    icon: "cross",
    size: 24,
    color: "#757575"
  })])])]), _createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, _toDisplayString($options.current?.seller_name) + " • " + _toDisplayString($options.current?.sku) + " - " + _toDisplayString($options.current?.asin), 1), _createElementVNode("div", _hoisted_13, _toDisplayString($options.current?.product_title_amazon), 1)]), _createElementVNode("div", _hoisted_14, [_createElementVNode("img", {
    src: $options.current?.main_image_link,
    alt: ""
  }, null, 8, _hoisted_15)])]), _createElementVNode("div", _hoisted_16, [_createElementVNode("div", _hoisted_17, [_createElementVNode("div", _hoisted_18, [_createVNode(_component_app_icon, {
    icon: "calendar",
    size: 16,
    color: "#757575"
  }), _createTextVNode(" Creation date ")]), _createElementVNode("div", _hoisted_19, _toDisplayString($options.createdAt), 1)]), _createElementVNode("div", _hoisted_20, [_createElementVNode("div", _hoisted_21, [_createVNode(_component_app_icon, {
    icon: "priority"
  }), _createTextVNode(" Priority ")]), $options.current?.alert_priority ? (_openBlock(), _createElementBlock("div", _hoisted_22, [_createVNode(_component_alerts_priority, {
    value: $options.current.alert_priority,
    items: $props.items,
    level: $options.current.alerting_category
  }, null, 8, ["value", "items", "level"])])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_23, [_createElementVNode("div", _hoisted_24, [_createVNode(_component_app_icon, {
    icon: "description"
  }), _createTextVNode(" Description ")]), _createElementVNode("div", _hoisted_25, _toDisplayString($options.current?.alerting_message), 1)]), _createElementVNode("div", _hoisted_26, [_createElementVNode("div", _hoisted_27, [_createVNode(_component_app_icon, {
    icon: "status"
  }), _createTextVNode(" Status ")]), $options.current?.status ? (_openBlock(), _createElementBlock("div", _hoisted_28, [_createVNode(_component_alerts_status, {
    modelValue: $options.current.status,
    "onUpdate:modelValue": [_cache[3] || (_cache[3] = $event => $options.current.status = $event), $options.onStatusChange]
  }, null, 8, ["modelValue", "onUpdate:modelValue"])])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_29, [_createElementVNode("div", _hoisted_30, [_createVNode(_component_app_icon, {
    icon: "assignee"
  }), _createTextVNode(" Assignee ")]), $options.current?.assignee ? (_openBlock(), _createElementBlock("div", _hoisted_31, [_createVNode(_component_alerts_assignee, {
    modelValue: $options.current.assignee,
    "onUpdate:modelValue": [_cache[4] || (_cache[4] = $event => $options.current.assignee = $event), $options.onAssigneeChange]
  }, null, 8, ["modelValue", "onUpdate:modelValue"])])) : _createCommentVNode("", true)])])])])])], 2);
}